import { ApiStatus } from '../../types';

export const personalDetailsDefaultContent = {
    heading: '{heading placeholder}',
    description: '{description placeholder}',
    contactDetailsHeading: '{contactDetailsHeading placeholder}',
    editContactDetailsText: '{editContactDetailsText}',
    email: {
        label: '{emailLabel}',
        checkboxLabel: '{emailCheckboxLabel placeholder}',
        infoLabel: '{emailInfoLabel placeholder}',
    },
    mobileNumber: {
        label: '{mobileNumberLabel}',
        checkboxLabel: '{mobileNumberCheckboxLabel placeholder}',
        infoLabel: '{mobileNumberInfoLabel placeholder}',
    },
    address: {
        label: '{currentAddressLabel placeholder}',
        checkboxLabel: '{useAddressAsMailingLabel placeholder}',
        infoLabel: '{currentAddressInfoLabel placeholder}',
    },
    residency: {
        label: '{residencyLabel placeholder}',
        editButtonText: '{editResidencyButtonText placeholder}',
        yesText: '{residencyYesText placeholder}',
        noText: '{residencyNoText placeholder}',
        saveButtonText: '{saveButtonText placeholder}',
        cancelButtonText: '{cancelButtonText placeholder}',
        radioOptions: [
            {
                'label': '{residencyRadioYesText placeholder}',
                'value': 'true',
            }, 
            {
                'label': '{residencyRadioNoText placeholder}',
                'value': 'false',
            },
        ],
    },
    driverLicence: {
        label: '{driverLicenceLabel placeholder}',
        editButtonText: '{editDriverLicenceButtonText placeholder}',
        additionalInfoLabel: '{driverLicenceAdditionalInfoLabel placeholder}',
        saveButtonText: '{driverLicenceSaveButtonText placeholder}',
        cancelButtonText: '{driverLicenceCancelButtonText placeholder}',
        validations: {
            maxLength: '{driverLicenceValidationMaxLength placeholder}',
            alphanumeric: '{driverLicenceValidationAlphanumeric placeholder}',
        },
    },
    profileModal: {
        heading: '{profileModalHeading placeholder}',
        description: '{profileModalDescription placeholder}',
    },
    nextStepHeading: '{nextStepHeading placeholder}',
    confirmButtonText: '{confirmButtonText placeholder}',
    updateButtonText: '{updateButtonText placeholder}',
    updateButtonLink: '#updateButtonLink-placeholder',
};

export interface PersonalDetailsEndpoints {
    getPersonalDetailsUrl: string;
}

export type PersonalDetailsContent = {
    heading: string,
    description: string,
    contactDetailsHeading?: string,
    editContactDetailsText?: string,
    email?: {
        label: string,
        checkboxLabel: string,
        infoLabel: string,
    },
    mobileNumber?: {
        label: string,
        checkboxLabel: string,
        infoLabel: string,
    },
    address?: {
        label: string,
        checkboxLabel: string,
        infoLabel: string,
    },
    residency?: {
        label: string,
        editButtonText: string,
        yesText: string,
        noText: string,
        saveButtonText: string,
        cancelButtonText: string,
        radioOptions: 
            {
                label: string,
                value: string,
            }[]
        ,
    },
    driverLicence?: {
        label: string,
        editButtonText: string,
        additionalInfoLabel: string,
        saveButtonText: string,
        cancelButtonText: string,
        validations: {
            maxLength: string,
            alphanumeric: string,
        },
    },
    profileModal?: {
        heading: string,
        description: string,
    },
    nextStepHeading: string,
    confirmButtonText: string,
    updateButtonText?: string,
    updateButtonLink?: string,
}

export interface PersonalDetailsInfo {
    address: string;
    mobileNumber?: string;
    email?: string;
    content: string;
    isResident?: boolean;
    driverLicenceNumber?: string;
}

export type DeletePersonalDetails = unknown;

export interface PersonalDetailsState {
    content: PersonalDetailsContent;
    apiEndpoints: PersonalDetailsEndpoints;
    personalInfo: {
        address: string;
        mobileNumber?: string;
        email?: string;
        isResident?: boolean;
        driverLicenceNumber?: string;
    };
    checkboxStates: Record<string, boolean>;
    isResidencyEditMode: boolean;
    getPersonalDetailsApiStatus: ApiStatus;
    deletePersonalDetailsApiStatus: ApiStatus;
    driverLicenceIsEditMode: boolean;
}
